/* "SHOW MORE" load-more — replaces numbered pagination on the collection grid
   AND the search results grid. Shared by sections/main-collection-product-grid
   and sections/main-search, so both behave identically.

   The two pages nest their grid differently:
     collection -> <ul id="product-grid" data-id="...">        (id on the list)
     search     -> <div id="product-grid" data-id="..."><ul class="product-grid">
   so the list element and the element carrying data-id are resolved separately.

   Search only — sold pieces last: search results are listed with
   options[unavailable_products]=hide (available pieces only). After the last
   available page the section renders a hidden button marked
   [data-oa-sold-start]; the search page script (sections/main-search.liquid,
   window.oaSearchSoldInit) reveals it and points it at the =show results.
   From then on this script is in "sold phase": it pages through the =show
   results and appends only the sold cards (li[data-oa-available="false"]),
   always exactly PAGE_SIZE per click — surplus sold cards from a fetched page
   wait in a buffer for the next click. When the available pieces end in the
   middle of a page (e.g. 8 available tank tops), the rest of that page is
   filled with sold pieces right away (window.oaLoadMoreSoldFill), so a page
   always shows 30 while there is anything left.
*/
(function () {
  if (window.__oaLoadMoreInit) return;
  window.__oaLoadMoreInit = true;

  // Products per page — matches the hard-coded paginate in main-search /
  // main-collection-product-grid.
  var PAGE_SIZE = 30;

  // Appended cards fade/slide in on scroll exactly like the first page:
  // they start "offscreen" (hidden by Dawn's scroll-trigger CSS) and get
  // Dawn's own onIntersection handler (assets/animations.js), which reveals
  // each one as it enters the viewport — cards that are already on screen
  // animate right away, with the usual cascade. Old cards are not touched.
  // Without the Dawn helper (animations off), the cards are shown at once.
  var revealObserver = null;
  function prepareReveal(item) {
    if (typeof window.onIntersection === 'function' && item.classList.contains('scroll-trigger')) {
      item.classList.add('scroll-trigger--offscreen');
    } else {
      item.classList.add('scroll-trigger--cancel');
    }
  }
  function startReveal(items) {
    if (typeof window.onIntersection !== 'function') return;
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(window.onIntersection, { rootMargin: '0px 0px -50px 0px' });
    }
    items.forEach(function (item) {
      if (item.classList.contains('scroll-trigger--offscreen')) revealObserver.observe(item);
    });
  }

  // The element that carries data-id (the section id used for the fetch).
  function gridRoot(doc) {
    return (doc || document).getElementById('product-grid');
  }

  // The <ul> the product <li>s actually live in.
  function gridList(root) {
    if (!root) return null;
    if (root.tagName === 'UL') return root;
    return root.querySelector('ul.product-grid') || root.querySelector('ul');
  }

  function updateShown(list) {
    var shownEl = document.querySelector('[data-load-more-shown]');
    if (shownEl) shownEl.textContent = list.querySelectorAll('.grid__item').length;
  }

  // Sold phase: append sold cards until the grid holds `target` cards (or
  // nothing is left). Pages through the =show results behind the button's
  // data-next-url; extra sold cards are kept in btn._oaBuffer for next time.
  function soldFill(btn, target) {
    var root = gridRoot(document);
    var list = gridList(root);
    var sectionId = root && root.dataset ? root.dataset.id : null;
    if (!list || !sectionId || btn.getAttribute('aria-busy') === 'true') return;
    btn._oaBuffer = btn._oaBuffer || [];
    btn.setAttribute('aria-busy', 'true');

    function step() {
      var added = [];
      while (btn._oaBuffer.length && list.querySelectorAll('.grid__item').length < target) {
        var node = btn._oaBuffer.shift();
        list.appendChild(node);
        added.push(node);
      }
      startReveal(added);
      var count = list.querySelectorAll('.grid__item').length;
      var nextUrl = btn.getAttribute('data-next-url');
      if (count >= target || !nextUrl) return finish();
      fetch(nextUrl + (nextUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId)
        .then(function (response) {
          return response.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var newList = gridList(gridRoot(doc));
          if (newList) {
            newList.querySelectorAll('.grid__item[data-oa-available="false"]').forEach(function (item) {
              var node = document.importNode(item, true);
              prepareReveal(node);
              btn._oaBuffer.push(node);
            });
          }
          var nextBtn = doc.querySelector('[data-load-more-button]:not([data-oa-sold-start])');
          if (nextBtn) btn.setAttribute('data-next-url', nextBtn.getAttribute('data-next-url'));
          else btn.removeAttribute('data-next-url');
          step();
        })
        .catch(function () {
          finish();
        });
    }

    function finish() {
      btn.removeAttribute('aria-busy');
      if (window.oaSwipeScan) {
        try { window.oaSwipeScan(); } catch (e) {}
      }
      updateShown(list);
      if (!btn._oaBuffer.length && !btn.getAttribute('data-next-url')) btn.remove();
    }

    step();
  }
  window.oaLoadMoreSoldFill = soldFill;

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-load-more-button]');
    if (!btn) return;
    event.preventDefault();

    var nextUrl = btn.getAttribute('data-next-url');
    if (!nextUrl || btn.getAttribute('aria-busy') === 'true') return;

    if (btn.hasAttribute('data-oa-sold-start')) {
      var soldList = gridList(gridRoot(document));
      var count = soldList ? soldList.querySelectorAll('.grid__item').length : 0;
      soldFill(btn, (Math.floor(count / PAGE_SIZE) + 1) * PAGE_SIZE);
      return;
    }

    var root = gridRoot(document);
    var list = gridList(root);
    var sectionId = root && root.dataset ? root.dataset.id : null;
    if (!list || !sectionId) {
      window.location.href = nextUrl;
      return;
    }

    btn.setAttribute('aria-busy', 'true');
    var url = nextUrl + (nextUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId;

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var newList = gridList(gridRoot(doc));
        if (newList) {
          var items = Array.prototype.slice.call(newList.querySelectorAll('.grid__item'));
          items.forEach(function (item) {
            prepareReveal(item);
            list.appendChild(item);
          });
          startReveal(items);
          // Defer the freshly-appended cards' swipe-gallery images (all but the
          // first photo per card) so loading more pages doesn't keep piling up
          // decoded images and exhaust mobile memory. Runs synchronously here,
          // before the browser's next lazy-load pass. No-op if the helper is absent.
          if (window.oaSwipeScan) {
            try { window.oaSwipeScan(); } catch (e) {}
          }
        }
        // Update the button's next URL, or remove it when there are no more pages.
        var nextBtn = doc.querySelector('[data-load-more-button]');
        if (nextBtn && nextBtn.hasAttribute('data-oa-sold-start')) {
          // End of the available search results: turn this button into the
          // (still hidden) "continue with sold pieces" button.
          btn.removeAttribute('aria-busy');
          btn.removeAttribute('data-next-url');
          btn.setAttribute('data-oa-sold-start', '');
          btn.setAttribute('data-oa-available-count', nextBtn.getAttribute('data-oa-available-count') || '0');
          btn.hidden = true;
          if (window.oaSearchSoldInit) window.oaSearchSoldInit();
        } else if (nextBtn) {
          btn.setAttribute('data-next-url', nextBtn.getAttribute('data-next-url'));
          btn.removeAttribute('aria-busy');
        } else {
          btn.remove();
        }
        // Update the visible "shown" count.
        var shownEl = document.querySelector('[data-load-more-shown]');
        if (shownEl) {
          shownEl.textContent = list.querySelectorAll('.grid__item').length;
        }
        // NOTE: intentionally do NOT touch the URL here. Writing ?page=N makes
        // a reload (or a Dawn facets popstate re-render) show ONLY page N as the
        // whole grid — the earlier products vanish and page N looks like the
        // first page. Keeping the address at the collection/search root means a
        // reload simply starts from the top again, which is the expected behaviour.
      })
      .catch(function () {
        btn.removeAttribute('aria-busy');
        window.location.href = nextUrl;
      });
  });
})();

/* Auto-load: the first AUTO_LOADS "Show more" pages load by themselves when the
   button comes into view (its label turns into three pulsing dots while it
   loads); every real click on SHOW MORE unlocks AUTO_LOADS more rounds, so the
   button only needs a click every 90 pieces. After that the SHOW MORE button is back, so the footer
   stays reachable and a phone never builds hundreds of cards just by scrolling
   (see the memory guard in oa-load-more.css). The count is kept on the grid
   element, so a filter/sort re-render (new grid) starts the auto phase over. */
(function () {
  if (window.__oaLoadMoreAuto) return;
  window.__oaLoadMoreAuto = true;
  if (!('IntersectionObserver' in window)) return;

  var AUTO_LOADS = 2;
  var DOTS_MIN_MS = 700;
  var observed = null;

  function grid() {
    return document.getElementById('product-grid');
  }
  function container() {
    return document.querySelector('[data-load-more]');
  }
  function button(box) {
    return box && box.querySelector('[data-load-more-button]:not([hidden])');
  }
  function autoLeft() {
    var g = grid();
    if (!g) return 0;
    return AUTO_LOADS - (g._oaAutoLoads || 0);
  }

  // The dots live INSIDE the button (they replace the label while loading).
  function ensureDots(box) {
    var btn = box.querySelector('[data-load-more-button]');
    if (btn && !btn.querySelector('.oa-load-more__dots')) {
      var d = document.createElement('span');
      d.className = 'oa-load-more__dots';
      d.setAttribute('aria-hidden', 'true');
      d.innerHTML = '<span></span><span></span><span></span>';
      btn.appendChild(d);
    }
  }

  function sync(box) {
    // Auto phase = there is a next page and auto loads are left — or the last
    // automatic load is still running (keep the dots until it has finished).
    var btn = button(box);
    var g = grid();
    var busy = !!btn && (btn.getAttribute('aria-busy') === 'true' || (g && g._oaAutoPending));
    if (g && !busy) g._oaAutoBusy = false;
    var auto = !!btn && (autoLeft() > 0 || (g && g._oaAutoBusy));
    box.classList.toggle('is-auto', auto);
    box.classList.toggle('is-loading', busy);
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var box = entry.target;
        var btn = button(box);
        var g = grid();
        if (!btn || !g || autoLeft() <= 0 || g._oaAutoPending || btn.getAttribute('aria-busy') === 'true') return;
        g._oaAutoLoads = (g._oaAutoLoads || 0) + 1;
        g._oaAutoBusy = true;
        g._oaAutoPending = true;
        box.classList.add('is-loading');
        // Let the dots pulse for a moment before the next page appears, so
        // the loading is actually seen (a fast fetch would only flash them).
        setTimeout(function () {
          g._oaAutoPending = false;
          btn.click();
        }, DOTS_MIN_MS);
      });
    },
    // Trigger just as the dots come into view (not far below the screen),
    // so the visitor sees them.
    { rootMargin: '0px 0px 80px 0px' }
  );

  function arm() {
    var box = container();
    if (!box) return;
    ensureDots(box);
    sync(box);
    if (observed !== box) {
      if (observed) io.unobserve(observed);
      observed = box;
      io.observe(box);
    }
  }

  // Re-arm when the grid / button changes (a page loaded, the button went
  // away, or Dawn's facets replaced the whole section). After a page has been
  // appended, re-observe so a still-visible container triggers the next load.
  var t = 0;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(function () {
      arm();
      var box = container();
      var btn = button(box);
      if (box && btn && btn.getAttribute('aria-busy') !== 'true' && autoLeft() > 0) {
        io.unobserve(box);
        io.observe(box);
      }
    }, 60);
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-busy', 'hidden'] });

  // A real click on SHOW MORE (not one of our automatic ones — those are
  // untrusted .click() calls) unlocks another AUTO_LOADS automatic rounds, so
  // browsing deep means one click per 90 pieces (30 clicked + 2 x 30 auto).
  document.addEventListener('click', function (e) {
    if (!e.isTrusted) return;
    if (!e.target.closest || !e.target.closest('[data-load-more-button]')) return;
    var g = grid();
    if (g) g._oaAutoLoads = 0;
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm);
  else arm();
})();
